export default "__VITE_ASSET__DjlbPkAW__"